<template>
  <div class="app-info-management">
    <div class="page-bg">
    <el-card shadow="never" class="animate__animated animate__fadeInUp main-card" v-loading="loading">
      <div v-if="error" class="error">{{ error }}</div>

      <!-- 工具栏 -->
      <div class="toolbar">
        <h3 class="toolbar-title">App信息管理</h3>
        <!-- <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建App</el-button> -->
      </div>

      <!-- 表格 -->
      <el-table
        v-if="!loading"
        :data="appList"
        row-key="id"
        border
        stripe
        class="app-table"
        empty-text="暂无App信息，请点击「新建App」添加"
      >
        <el-table-column prop="name" label="名称" min-width="100" show-overflow-tooltip>
          <template #default="{ row }">{{ row.name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="packageName" label="包名" min-width="120" show-overflow-tooltip>
          <template #default="{ row }">{{ row.packageName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="storeName" label="上架平台" min-width="90">
          <template #default="{ row }">{{ row.storeName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="versionCode" label="版本号" width="90" />
        <el-table-column prop="downloadUrl" label="下载地址" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">
            <a v-if="row.downloadUrl" :href="row.downloadUrl" target="_blank" class="link-text">{{ row.downloadUrl }}</a>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="Logo" width="80" align="center">
          <template #default="{ row }">
            <el-image
              v-if="row.logo"
              :key="row.id + '-logo'"
              :src="imgUrl(row.logo)"
              fit="contain"
              class="table-thumb"
              :preview-src-list="[imgUrl(row.logo)]"
            />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="80" align="center">
          <template #default="{ row }">
            <el-image
              v-if="row.qrCodeUrl"
              :key="row.id + '-qr'"
              :src="imgUrl(row.qrCodeUrl)"
              fit="contain"
              class="table-thumb"
              :preview-src-list="[imgUrl(row.qrCodeUrl)]"
            />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="当前版本" width="90" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.isNow === 1 || row.isNow === true" type="success" size="small">当前</el-tag>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger-text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    </div>

    <!-- 新建/编辑表单弹窗 -->
    <el-dialog
      :title="isEdit ? '编辑App信息' : '新建App信息'"
      :visible.sync="dialogVisible"
      width="640px"
      append-to-body
      custom-class="app-info-dialog"
      :close-on-click-modal="false"
      @close="cancelForm"
    >
      <el-form ref="appForm" :model="form" :rules="rules" label-width="88px" class="app-info-form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入App名称" maxlength="16" show-word-limit />
        </el-form-item>
        <el-form-item label="包名" prop="packageName">
          <el-input v-model="form.packageName" placeholder="请输入包名" maxlength="32" show-word-limit />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="上架平台" prop="storeName">
              <el-input v-model="form.storeName" placeholder="请输入上架平台" maxlength="16" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="版本号" prop="versionCode">
              <el-input v-model="form.versionCode" placeholder="请输入版本号" maxlength="16" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="下载地址" prop="downloadUrl">
          <el-input v-model="form.downloadUrl" placeholder="请输入下载地址" maxlength="255" show-word-limit />
        </el-form-item>

        <!-- 当前版本开关 -->
        <el-form-item label="当前版本">
          <el-switch
            v-model="form.isNow"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ddd"
            active-text="是"
            inactive-text="否"
            @change="onIsNowChange"
          />
          <span class="isnow-tip">只能有一个App设为"当前版本"，切换后其他自动取消</span>
        </el-form-item>

        <div class="upload-section">
          <div class="upload-section-title">应用图标（jpg / png，不超过 2MB）</div>
          <div class="upload-row">
            <div class="upload-col" :class="{ 'is-full': logoFileList.length >= 1 }">
              <span class="upload-col-label">Logo</span>
              <el-upload
                class="upload-box"
                :action="uploadAction"
                :headers="uploadHeaders"
                :file-list="logoFileList"
                :limit="1"
                :show-file-list="true"
                :on-success="onLogoSuccess"
                :on-remove="onLogoRemove"
                :before-upload="beforeLogoUpload"
                :auto-upload="false"
                :on-change="onLogoChange"
                :on-exceed="onLogoExceed"
                list-type="picture-card"
                accept="image/*"
              >
                <i v-if="logoFileList.length === 0" class="el-icon-plus upload-plus"></i>
              </el-upload>
            </div>
            <div class="upload-col" :class="{ 'is-full': qrCodeFileList.length >= 1 }">
              <span class="upload-col-label">二维码</span>
              <el-upload
                class="upload-box"
                :action="uploadAction"
                :headers="uploadHeaders"
                :file-list="qrCodeFileList"
                :limit="1"
                :show-file-list="true"
                :on-success="onQrCodeSuccess"
                :on-remove="onQrCodeRemove"
                :before-upload="beforeQrCodeUpload"
                :auto-upload="false"
                :on-change="onQrCodeChange"
                :on-exceed="onQrCodeExceed"
                list-type="picture-card"
                accept="image/*"
              >
                <i v-if="qrCodeFileList.length === 0" class="el-icon-plus upload-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          {{ isEdit ? '保存修改' : '创建' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, del, BASE_URL, IMG_BASE_URL, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'AppInfoManagement',
  data() {
    return {
      loading: false,
      error: '',
      appList: [],
      dialogVisible: false,
      isEdit: false,
      editId: null,
      submitting: false,
      form: {
        name: '',
        packageName: '',
        storeName: '',
        downloadUrl: '',
        versionCode: '',
        isNow: 0
      },
      logoFile: null,
      qrCodeFile: null,
      logoFileList: [],
      qrCodeFileList: [],
      clearLogo: false,
      clearQrCode: false,
      rules: {
        versionCode: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ]
      },
      uploadAction: '/common/upload',
      uploadHeaders: {}
    }
  },
  mounted() {
    this.uploadHeaders = {
      token: localStorage.getItem('token') || ''
    }
    this.fetchList()
  },
  methods: {
    imgUrl(path) {
      if (!path) return ''
      return path.startsWith('http') ? path : IMG_BASE_URL + path
    },

    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const result = await get('/admin/app/list')
        const list = result.data || []
        list.sort((a, b) => {
          const aNow = (a.isNow === 1 || a.isNow === true) ? 0 : 1
          const bNow = (b.isNow === 1 || b.isNow === true) ? 0 : 1
          return aNow - bNow
        })
        this.appList = list
      } catch (e) {
        this.appList = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },

    openCreate() {
      this.isEdit = false
      this.editId = null
      this.form = {
        name: '',
        packageName: '',
        storeName: '',
        downloadUrl: '',
        versionCode: '',
        isNow: 0
      }
      this.logoFile = null
      this.qrCodeFile = null
      this.logoFileList = []
      this.qrCodeFileList = []
      this.clearLogo = false
      this.clearQrCode = false
      this.dialogVisible = true
    },

    openEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        name: row.name || '',
        packageName: row.packageName || '',
        storeName: row.storeName || '',
        downloadUrl: row.downloadUrl || '',
        versionCode: row.versionCode || '',
        isNow: row.isNow === 1 || row.isNow === true ? 1 : 0
      }
      this.logoFile = null
      this.qrCodeFile = null
      this.logoFileList = row.logo
        ? [{ name: 'logo', url: this.imgUrl(row.logo) }]
        : []
      this.qrCodeFileList = row.qrCodeUrl
        ? [{ name: 'qrCode', url: this.imgUrl(row.qrCodeUrl) }]
        : []
      this.clearLogo = false
      this.clearQrCode = false
      this.dialogVisible = true
    },

    cancelForm() {
      this.dialogVisible = false
      this.isEdit = false
      this.editId = null
      this.form = {
        name: '',
        packageName: '',
        storeName: '',
        downloadUrl: '',
        versionCode: '',
        isNow: 0
      }
      this.logoFile = null
      this.qrCodeFile = null
      this.logoFileList = []
      this.qrCodeFileList = []
      this.$nextTick(() => {
        if (this.$refs.appForm) this.$refs.appForm.clearValidate()
      })
    },

    onIsNowChange(val) {
      if (val === 1) {
        // 如果当前列表中已有其他"当前版本"，给出提示
        const cur = this.appList.find(r => r.id !== this.editId && (r.isNow === 1 || r.isNow === true))
        if (cur) {
          this.$notify.info({
            title: '提示',
            message: `保存后「${cur.name || 'ID:' + cur.id}」将自动取消当前版本标记`,
            duration: 3000
          })
        }
      }
    },

    onLogoChange(file, fileList) {
      this.logoFile = file.raw
      this.logoFileList = fileList.slice(-1)
    },
    onLogoExceed() {
      this.$message.warning('Logo 只能上传 1 张图片')
    },
    onLogoSuccess(res) {
      this.logoFileList = [{ name: 'logo', url: res.data }]
    },
    onLogoRemove() {
      this.logoFile = null
      this.logoFileList = []
      this.clearLogo = true
    },
    beforeLogoUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('Logo 必须是图片格式')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Logo 大小不能超过 2MB')
        return false
      }
      return true
    },

    onQrCodeChange(file, fileList) {
      this.qrCodeFile = file.raw
      this.qrCodeFileList = fileList.slice(-1)
    },
    onQrCodeExceed() {
      this.$message.warning('二维码只能上传 1 张图片')
    },
    onQrCodeSuccess(res) {
      this.qrCodeFileList = [{ name: 'qrCode', url: res.data }]
    },
    onQrCodeRemove() {
      this.qrCodeFile = null
      this.qrCodeFileList = []
      this.clearQrCode = true
    },
    beforeQrCodeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('二维码 必须是图片格式')
        return false
      }
      if (!isLt2M) {
        this.$message.error('二维码 大小不能超过 2MB')
        return false
      }
      return true
    },

    async handleSubmit() {
      if (!this.$refs.appForm) return
      await this.$refs.appForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          const formData = new FormData()
          if (this.form.name) formData.append('name', this.form.name)
          if (this.form.packageName) formData.append('packageName', this.form.packageName)
          if (this.form.storeName) formData.append('storeName', this.form.storeName)
          if (this.form.downloadUrl) formData.append('downloadUrl', this.form.downloadUrl)
          formData.append('versionCode', this.form.versionCode)
          formData.append('isNow', this.form.isNow)

          if (this.logoFile) {
            formData.append('logoFile', this.logoFile)
          } else if (this.clearLogo && this.isEdit) {
            formData.append('logoFile', '')
          }
          if (this.qrCodeFile) {
            formData.append('qrCodeFile', this.qrCodeFile)
          } else if (this.clearQrCode && this.isEdit) {
            formData.append('qrCodeFile', '')
          }

          const token = localStorage.getItem('token')
          const url = this.isEdit ? `${BASE_URL}/admin/app/${this.editId}` : `${BASE_URL}/admin/app`
          const method = this.isEdit ? 'PUT' : 'POST'

          const response = await fetch(url, {
            method,
            headers: {
              ...(token && { token })
            },
            body: formData
          })

          const result = await response.json()
          const isSuccess = result.code === 200 || result.code === 1
          if (isSuccess) {
            const successMsg = getResponseMessage(result, this.isEdit ? '编辑成功' : '创建成功')
            this.dialogVisible = false
            this.isEdit = false
            this.editId = null
            this.$message.success(successMsg)
            await this.fetchList()
          } else {
            throw new Error(result.msg || '操作失败')
          }
        } catch (e) {
          this.$message.error(e.message || '操作失败')
        } finally {
          this.submitting = false
        }
      })
    },

    async handleDelete(row) {
      try {
        await this.$confirm(`确定要删除App「${row.name || 'ID:' + row.id}」吗？此操作不可撤销。`, '警告', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const result = await del(`/admin/app/${row.id}`)
        this.$message.success(getResponseMessage(result, '删除成功'))
        await this.fetchList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e && e.message ? e.message : '删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.page-bg {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #eef1f6 50%, #f8f9fb 100%);
}

.main-card {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.toolbar-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1d1d1f;
  letter-spacing: -0.2px;
}

.app-table {
  width: 100%;
}

.table-thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.text-muted {
  color: #c0c4cc;
  font-size: 12px;
}

.danger-text {
  color: #f56c6c !important;
}
.danger-text:hover {
  color: #f78989 !important;
}

.isnow-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #9ca3af;
  letter-spacing: 0.05px;
}

.empty-state {
  padding: 40px 0;
}

.link-text {
  color: #2563eb;
  font-size: 12px;
  word-break: break-all;
}
.link-text:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.upload-section {
  margin-top: 4px;
  padding: 20px 20px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  transition: border-color 0.2s;
}

.upload-section:hover {
  border-color: #d1d5db;
}

.upload-section-title {
  margin-bottom: 14px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: 0.1px;
}

.upload-row {
  display: flex;
  gap: 32px;
}

.upload-col {
  flex: 1;
  min-width: 0;
}

.upload-col-label {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: 0.1px;
}

.upload-col.is-full >>> .el-upload--picture-card {
  display: none;
}

.upload-box >>> .el-upload--picture-card,
.upload-box >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
  margin: 0;
  border-radius: 8px;
  border-color: #dcdfe6;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.upload-box >>> .el-upload--picture-card:hover {
  border-color: #409eff;
}

.upload-box >>> .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
}

.upload-plus {
  font-size: 22px;
  color: #9ca3af;
}

.error {
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.el-card.animate__animated {
  --animate-duration: 0.3s;
}
</style>

<style>
.app-info-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.app-info-dialog .el-dialog__header {
  padding: 20px 24px 16px;
  background: #fafbfc;
  border-bottom: 1px solid #e5e7eb;
}

.app-info-dialog .el-dialog__title {
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  letter-spacing: -0.2px;
}

.app-info-dialog .el-dialog__body {
  padding: 24px 24px 12px;
  background: #fff;
}

.app-info-dialog .el-dialog__footer {
  padding: 14px 24px 18px;
  background: #fafbfc;
  border-top: 1px solid #e5e7eb;
}

.app-info-dialog .dialog-footer .el-button {
  min-width: 88px;
  border-radius: 6px;
  font-weight: 500;
}

.app-info-form .el-form-item {
  margin-bottom: 20px;
}

.app-info-form .el-form-item__label {
  color: #374151;
  font-size: 13px;
  font-weight: 500;
}
</style>
